export const isNotFoundSpaceError = (error: Error): boolean =>
	error.message?.includes('Cannot find space');
